import React from 'react';
import { Terminal } from 'xterm';
import './xterm.css';
import { connect } from 'react-redux';
import Paho from 'paho-mqtt';
import Button from '../button/Button';
import { FitAddon } from 'xterm-addon-fit';


var terminal;


class XTerminal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            client: "",
            data: [],
            statusTerminal: "",
            setButtons: false,
            username: "",
            password: ""
        }
        this.handleMenu = this.handleMenu.bind(this);
        this.handleRun = this.handleRun.bind(this);
        this.startTerminal = this.startTerminal.bind(this);
    }

    startTerminal() {
        if(this.state.statusTerminal === "") {
            
            var user = this.props.user.auth.user
            terminal = new Terminal({cursorBlink: true});
            const fitAddon = new FitAddon();
            terminal.loadAddon(fitAddon);
            terminal.open(this.refs.terminal);
            fitAddon.fit();

            this.setState({ statusTerminal: "open" });

            const client = new Paho.Client("37.148.211.63", Number(9001), user.email);//String.raw`${this.state.data.identity}`);

            // set callback handlers
            client.onConnectionLost = (responseObject) => {
                if (responseObject.errorCode !== 0) {
                    console.log("onConnectionLost:"+responseObject.errorMessage);
                }
            }
            client.onMessageArrived = (message) => {
                let _msg = JSON.parse(message.payloadString)
                //console.log(_msg)
                if (_msg.code === 1){
                    let msg = String.raw`${_msg.data}`
                    let y = msg.split(String.raw`\x1B`).join('\x1B')
                    terminal.write(y)
                }
                else if(_msg.code === 6){
                    alert("Cihaz Sample almaktadır. Bekleme Süresi: En fazla 45 saniye.")
                }


            };
            
            // connect the client
            client.connect({onSuccess:() => { 

                this.setState({client})
                this.setState({ setButtons : true })
                client.subscribe(this.props.deviceAttributes.publishName);

                const data = JSON.stringify({"LiveConnect": "True", "command" : "Run"})
                const run = new Paho.Message(data);
                run.destinationName = this.props.deviceAttributes.subscribeName;
                this.state.client.send(run);
                
            },
            userName: this.state.username,
            password: this.state.password
        });
        } else {
            this.setState({ statusTerminal: "" });
            //client.disconnet()
            
        }

    }

    
    componentWillMount() {
        fetch("/service/getmqttcredentials")
        .then(res => res.json())
        .then(data => {
            this.setState({
                username: data.username,
                password: data.password
            })
        })
    };

    handleMenu() {
        const data = JSON.stringify({"LiveConnect": "True", "command" : "Menu"})
        const menu = new Paho.Message(data);
        menu.destinationName = this.props.deviceAttributes.subscribeName;
        this.state.client.send(menu);
    }

    handleRun() {
        const data = JSON.stringify({"LiveConnect": "True", "command" : "Run"})
        const run = new Paho.Message(data);
        run.destinationName = this.props.deviceAttributes.subscribeName;
        this.state.client.send(run);
    }



    render() {
        return(
            <div>
                <div ref="terminal" style={{maxWidth:"700px"}}></div>

                    {
                        this.state.setButtons ? (
                            <div>
                                <Button
                                className='c-btn c-success c-btn-round ma-5'
                                    onClick={this.handleMenu}
                                >
                                    Menu
                                </Button>

                                <Button
                                    className='c-btn c-danger c-btn-round ma-5'
                                    onClick={this.handleRun}
                                >
                                    Run
                                </Button>
                            </div>
                        ) : (
                            <div>
                                <Button
                                    className='c-btn c-success c-btn-round ma-5'
                                    onClick={this.startTerminal}
                                >
                                    Terminali Başlat
                                </Button> 
                            </div>                     
                        )
                    }
            </div>

        )
    }
}

function mapStateToProps(state) {
    return { user: state };
  }

export default connect(mapStateToProps)(XTerminal);